import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { ProductFilters } from '../ProductFilters/ProductFilters';
import { collection, CollectionState } from '@/services/collection';

@Component
export class CollectionActiveFilters extends ThemeComponent {
    @Ref({ required: false }) removeFilter!: HTMLElement[];

    init() {

        // Init remove filter click event listeners
        this.initRemoveFilterClickEventListeners();
    }

    initRemoveFilterClickEventListeners() {
        for (const removeFilter of this.removeFilter) {
            this.$listen(removeFilter, 'click', (e) => {

                // Prevent default
                e.preventDefault();

                // Get clicked element
                let clickedElement = e.target as HTMLElement;
                if (clickedElement.tagName !== 'A') {
                    clickedElement = clickedElement.closest('a') as HTMLElement;
                }

                // Get href from clicked element
                const href = clickedElement.getAttribute('href');
                if (href) {

                    // Define new state
                    const state = collection.parseState(href);
                    const newState: CollectionState = {
                        ...state,
                        page: undefined,
                    };

                    // Load new section
                    void collection.update(newState);
                }

                // Let product filters handle any actions
                const productFiltersElement = document.querySelector('.product-filters');
                if (productFiltersElement) {
                    const productFilters = productFiltersElement as ProductFilters;
                    const filterIdToRemove = removeFilter.getAttribute('data-filter-id-to-remove');
                    if (filterIdToRemove) {
                        productFilters.handleFilterRemoved(filterIdToRemove);
                    }
                }
            });
        }
    }
}
